export const UNAUTHORISED_EVENT = 'syl-unauthorised-user'
